import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MESSAGES} from '../util/message';

@Component({
  selector: 'app-digital-signature-dialog-info',
  templateUrl: './digital-signature-dialog-info.component.html',
  styleUrls: ['./digital-signature-dialog-info.component.scss']
})
export class DigitalSignatureDialogInfoComponent {
  selectPage = MESSAGES.SELECT_PAGE;
  browserProblemAdvise = MESSAGES.BROWSER_PROBLEM;

  constructor(private dialogRef: MatDialogRef<DigitalSignatureDialogInfoComponent>) {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
